import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traducciones
import esTranslations from './locales/es.json';
import enTranslations from './locales/en.json';

i18n
  .use(LanguageDetector) // Detecta el idioma del navegador
  .use(initReactI18next) // Pasa i18n a react-i18next
  .init({
    resources: {
      es: {
        translation: esTranslations
      },
      en: {
        translation: enTranslations
      }
    },
    fallbackLng: 'es', // Idioma por defecto
    lng: 'es', // Idioma inicial
    supportedLngs: ['es', 'en'],
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false // React ya escapa valores
    },
    
    detection: {
      // Orden de detección de idioma
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'], // Guarda el idioma seleccionado
      lookupLocalStorage: 'javiland-language'
    }
  });

export default i18n;

